import slugify from "slugify"
import appConf from "./config"

/*
const equal = (a, b) => {
    const replacerA =
        typeof a !== "undefined" &&
        a !== null &&
        !Array.isArray(a) &&
        typeof a === "object"
            ? Object.keys(a).sort()
            : undefined
    const replacerB =
        typeof b !== "undefined" &&
        b !== null &&
        !Array.isArray(b) &&
        typeof b === "object"
            ? Object.keys(b).sort()
            : undefined

    return JSON.stringify(a, replacerA) == JSON.stringify(b, replacerB)
}
*/

function isObject(object) {
    return object != null && typeof object === "object"
}

function deepEqual(object1, object2) {
    if (!object1 && !object2) {
        return true
    }
    if (isObject(object1) && isObject(object2)) {
        const keys1 = Object.keys(object1)
        const keys2 = Object.keys(object2)

        if (keys1.length !== keys2.length) {
            return false
        }

        for (const key of keys1) {
            const val1 = object1[key]
            const val2 = object2[key]
            if (!deepEqual(val1, val2)) {
                return false
            }
        }

        return true
    } else {
        return object1 == object2
    }
}

const fillDiff = (obj: Nav | Product, onlineField: string, data: any, useString?: boolean) => {
    const sourceData = useString || typeof data != "string" ? data : obj.xlsRow && obj.xlsRow[data]

    if (!deepEqual(obj.online && obj.online[onlineField], data)) {
        obj.diff[onlineField] = data
    }
}

export const diffNavEntry = (n: Nav): boolean => {
    n.diff = {}

    const children: string[] = []
    n.subNav.forEach((sub) => children.push(sub.id))

    const filter: any[] = []
    n.xlsRow?.NavFilter?.split(",").forEach((f) => {
        filter.push({ context: f.trim() })
    })

    const config: any[] = []
    n.xlsRow?.NavKonfigurator?.split(",").forEach((c) => {
        config.push({ context: c.trim() })
    })

    let title = {}
    title[appConf.defaultLanguage] = n.xlsRow?.Title?.trim()
    let teaser_text = {}
    teaser_text[appConf.defaultLanguage] = n.xlsRow?.Description?.trim()
    let button_text = {}
    button_text[appConf.defaultLanguage] = n.xlsRow?.Buttontext?.trim()

    let images: any[] = []
    n.xlsRow?.Image?.split(/[\n\r,]/).forEach((b: string) => {
        b = b.trim()
        if (b) {
            images.push({
                file: {
                    path: b,
                    src: appConf.categoryImageBase + b,
                    type: "image/jpeg",
                },
            })
        }
    })

    const dataMap = [
        ["is_root", n.name[appConf.defaultLanguage] == "root" || null],
        ["name", n.name],
        ["title", title[appConf.defaultLanguage] ? title : null],
        ["button_text", button_text[appConf.defaultLanguage] ? button_text : null],
        ["path", n.path],
        ["children", children],
        ["filter", filter],
        ["filterConfig", config],
        ["image", images.length ? images[0]?.file : null],
        ["images", images],
        ["teaser_text", teaser_text[appConf.defaultLanguage] ? teaser_text : null],
    ]
    dataMap.forEach((d) => fillDiff(n, d[0].toString(), d[1], d.length > 2 && !!d[2]))

    return Object.keys(n.diff).length > 0
}

export const diffProductEntry = (p: Product): boolean => {
    p.diff = {}

    let images: any[] = []
    p.xlsRow?.Image?.split(/[\n\r,]/).forEach((b: string) => {
        b = b.trim()
        if (b) {
            const c = p.xlsRow?.xFarbe
            const s = p.xlsRow?.xSprechfeld
            if (
                (!c ||
                    !b.match(/_\d{4}\.(jpe?g|mp4|m3u8?)$/i) ||
                    b.match(new RegExp("_" + c + ".(jpe?g|mp4|m3u8?)$", "i"))) &&
                (!s ||
                    (s != 2 && s != 3) || // nicht sprechfeld links oder rechts
                    (s == 2 && !b.match(/_L/)) || // sprechfeld rechts und nicht mit _L
                    (s == 3 && b.match(/_L/))) // sprechfeld links und mit _L
            ) {
                let type = "image/jpeg"
                let base = appConf.productImageBase
                if (b.match(/\.mp4$/i)) {
                    type = "video/mp4"
                    base = appConf.productVideoBase
                } else if (b.match(/\.m3u8?$/i)) {
                    type = "application/x-mpegURL"
                    base = appConf.productVideoBase
                }
                images.push({
                    file: {
                        path: b,
                        src: base + b,
                        type,
                    },
                })
            }
        }
    })

    let downloads: any = {}

    let downloadsDEFAULT: { label: string; file: any }[] = []
    p.xlsRow?.Downloads?.split(/[\n\r]/).forEach((d) => {
        d = d.trim()
        if (d) {
            let parts = d.split(":")
            let fileSrc = parts.length && parts[0].trim()
            let label = parts.length > 1 && parts[1].trim()
            if (!label) label = fileSrc
            downloadsDEFAULT.push({
                label,
                file: {
                    path: fileSrc,
                    src: appConf.productDownloadBase + fileSrc,
                    type: "application/pdf",
                },
            })
        }
    })
    if (downloadsDEFAULT?.length) downloads[appConf.defaultLanguage] = downloadsDEFAULT

    const configParams: { [key: string]: number } = {}
    ;[
        ["BK_Anzahl_Briefkasten", "postboxes_count"],
        ["BK_Einbauart", "installation_type_code"],
        ["xSprechfeld", "intercom_bell_code"],
        ["BK_Produktlinie", "line_code"],
        ["BK_Größe_Briefkasten", "postbox_size_code"],
        ["BK_Oberfläche", "surface_code"],

        // ["PK_Anlagenart", "system_type_code"],
        ["PK_Bedienung", "operation_type_code"],
        // ["PK_Briefkästen", "postboxes_count"],
        // ["PK_Paketfächer", "packageboxes_code"],
        ["PK_Funktion", "division_code"],
        ["PK_Paketkastengröße", "packagebox_size_code"],
        ["PK_Postentnahme", "mail_removal_code"],
        // ["PK_Klingel", "intercom_bell_code"],
        ["PK_Dachform", "roof_type_code"],
    ].forEach((k) => {
        if (p.xlsRow && typeof p.xlsRow[k[0]] == "number") {
            const c = parseInt(p.xlsRow[k[0]])
            if (c >= 0) {
                configParams[k[1]] = c
            }
        }
    })

    const filterParams: { [key: string]: number | number[] } = {}
    ;[
        ["Available colors", "color_code"],
        // for split entries
        ["xFarbe", "color_code"],
        ["Package Size", "size", "string"],
        ["Punch width", "punching_width"],
        ["Punch height", "punching_height"],
        ["Outer dimension width", "external_dimension_width"],
        ["Outer dimension height", "external_dimension_height"],
        ["Year of manufacture from", "year_of_construction_from"],
        ["Year of manufacture until", "year_of_construction_to"],
    ].forEach((k) => {
        if (p.xlsRow && p.xlsRow[k[0]]) {
            switch (k.length > 2 && k[2]) {
                case "string":
                    filterParams[k[1]] = p.xlsRow[k[0]]
                    break
                default:
                    const c = parseFloat(p.xlsRow[k[0]])
                    if (c > 0) {
                        filterParams[k[1]] = c
                    }
            }
        }
    })

    const materials: number[] = []
    ;["Plastic", "Aluminum", "Stainless steel"].forEach((k, idx) => {
        let m: string = p.xlsRow && p.xlsRow[k]
        if (m) {
            m = m.toString().trim().toLowerCase()
            if (m === "x" || m === "1" || m === "ja") {
                materials.push(idx + 1)
            }
        }
    })
    if (materials.length) {
        filterParams.materials = materials
    }

    const options: { option: string; code?: number; price_net: number }[] = []
    ;[
        [" Bruttopreis RAL ", undefined, "ral"],
        ["BK_Bruttopreis_RSA2-Ausstattung", "BK_Option_RSA2-Ausstattung", "rsa2"],
        ["BK_Bruttopreis_Option_NS_Standard", "BK_Option_2tes_NS_Standard", "-rsa2#second_name_tag"],
        ["BK_Bruttopreis_2tes_NS_RSA2", "BK_Option_2tes_NS_RSA2", "rsa2#second_name_tag"],
        ["BK_Bruttopreis_RS50", "BK_Option_RS50", "rs50"],
        ["BK_Bruttopreis_RSK", "BK_Option_RSK", "rsk"],
        ["BK_Bruttopreis_RSA2_mit_Gravur", "BK_Option_RSA2_mit_Gravur", "rsa2#engraving"],
        ["BK_Bruttopreis_Installationskasten_links", "BK_Option_Installationskasten_links", "installation_box_left"],
    ].forEach((k) => {
        const price: number = p.xlsRow && parseFloat(p.xlsRow[k[0]])
        if (!isNaN(price)) {
            const o: any = {}
            if (k[1]) {
                // code column
                const code: number = parseInt(p.xlsRow[k[1]])
                if (code > 0) {
                    o.code = code
                }
            }
            o.option = k[2]
            if (o.option == "ral") {
                if (price && price > 0) {
                    // Preis RAL ist kein Aufpreis, sondern Endpreis, daher zum Aufpreis in DB machen
                    o.price_net = Math.round((price - parseFloat(p.xlsRow["Price net"])) * 100) / 100
                    if (o.price_net < 0) {
                        // kein Aufpreis, daher kein RAL Produkt
                        return
                    }
                } else {
                    // für RAL ist 0,00 bei Edelstahl eingetragen, daher hier abbrechen
                    return
                }
            } else {
                o.price_net = price
            }
            options.push(o)
        }
    })

    const user_inputs: { [key: string]: number | number[] } = {}
    ;[
        ["Engraving line 1", "engraving_line_length_1", parseFloat],
        ["Engraving line 2", "engraving_line_length_2", parseFloat],
        ["Engraving line 3", "engraving_line_length_3", parseFloat],
        ["Key number from", "key_number_range_from", parseFloat],
        ["Key number to", "key_number_range_to", parseFloat],
        ["Any key number", "key_number_random_ok", (x) => !!x],
    ].forEach((k) => {
        if (p.xlsRow && p.xlsRow[k[0] as string]) {
            const c = (k[2] as Function)(p.xlsRow[k[0] as string])
            if (c > 0) {
                user_inputs[k[1] as string] = c
            }
        }
    })

    let slug = {}
    slug[appConf.defaultLanguage] = slugify(p.xlsRow?.Title?.toString() || "unknown", {
        lower: true,
        locale: appConf.defaultLanguage,
    })

    const name = {}
    name[appConf.defaultLanguage] = p.xlsRow?.Title?.toString()
    const description = {}
    description[appConf.defaultLanguage] = p.xlsRow?.Description?.toString()

    const variant_name = {}
    variant_name[appConf.defaultLanguage] = p.xlsRow && p.xlsRow["Variants affiliation"]?.toString()

    const code = p.code?.toString()
    const base_code = p.xlsRow?.["Item number"]?.toString()
    // base_code + suffix = code
    const code_suffix = p.code && p.code.toString().replace(base_code, "")
    const dataMap: [string, any, boolean?][] = [
        ["code", code, true],
        ["base_code", base_code, true],
        ["gtin", p.xlsRow?.["GTIN-NUMBER"]?.toString(), true],
        ["categories", [p.nav.id]],
        ["name", name],
        ["slug", slug],
        ["popular", p.xlsRow && p.xlsRow["Popular products"] ? parseInt(p.xlsRow["Popular products"]) : null],
        ["sort", parseInt(p.xlsRow?.Sorting)],
        ["description", description],
        ["price_net", parseFloat(p.xlsRow["Price net"])],
        [
            "price_net_end_customer",
            p.xlsRow["Special offer price"]
                ? parseFloat(p.xlsRow["Special offer price"])
                : parseFloat(p.xlsRow["Price net"]),
        ],
        [
            "price_net_dealer",
            p.xlsRow["Fixed dealer price"]
                ? parseFloat(p.xlsRow["Fixed dealer price"])
                : parseFloat(p.xlsRow["Price net"]),
        ],
        ["price_net_dealer_is_fixed", !!p.xlsRow["Fixed dealer price"]],
        ["apply_pricing_rules", !!p.xlsRow["UVP-Regel "]],
        ["shipping_factor", p.xlsRow["Shipping factor"] ? parseFloat(p.xlsRow["Shipping factor"]) : null],
        ["delivery_time", parseInt(p.xlsRow["Delivery time"])],
        ["images", images],
        ["downloads", downloads],
        ["config_params", configParams],
        ["filter_params", filterParams],
        ["options", options],
        ["lasersheet_configurator", !!p.xlsRow?.["Lasersheet Configurator"]],
        ["user_inputs", user_inputs],
        ["related_codes", p.xlsRow?.xRelated || []],
        ["variant_name", variant_name[appConf.defaultLanguage] ? variant_name : null],
        ["variant_codes", p.xlsRow?.xVariants?.map((v) => v + code_suffix) || []],
        ["inquiry", !!p.xlsRow?.Anfrage],
        ["no_dealers", !!p.xlsRow?.["No dealers"]],
    ]
    dataMap.forEach((d) => fillDiff(p, d[0].toString(), d[1], d.length > 2 && !!d[2]))

    const isDiff = Object.keys(p.diff).length > 0

    return isDiff
}
